import { render, staticRenderFns } from "./GoogleAds.vue?vue&type=template&id=bd89608c&scoped=true&"
import script from "./GoogleAds.vue?vue&type=script&lang=js&"
export * from "./GoogleAds.vue?vue&type=script&lang=js&"
import style0 from "./GoogleAds.vue?vue&type=style&index=0&id=bd89608c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd89608c",
  null
  
)

export default component.exports